import { Fragment } from 'react';
import { useParams } from 'react-router-dom';

import { Spinner } from '@components/loading-spinner';
import { TooltipStyles } from '@components/tooltip';
import { DatePickerStyles } from '@styles/datepicker';

import { useJourneyForm, useSaveJourneyForm } from 'api/form';

import { DisplayForm } from './display-form';
import { JourneyFormLoadError } from './journey-form-load-error';
import { SubmissionSuccess } from './submission-success';

type RouteParams = {
  journeyUuid: string;
  formUuid: string;
};

export const JourneyForm = () => {
  const { formUuid, journeyUuid } = useParams() as RouteParams;
  const formQuery = useJourneyForm(journeyUuid, formUuid);
  const saveMutation = useSaveJourneyForm(journeyUuid, formUuid);

  if (formQuery.isLoading) {
    return <Spinner />;
  }

  if (!formQuery.data?.hasPublishedJourney) {
    return <div></div>;
  }

  return (
    <Fragment>
      <DatePickerStyles />
      <TooltipStyles />

      {saveMutation.isSuccess && (
        <SubmissionSuccess submissionMessageConfig={formQuery.data?.submissionMessageConfig} />
      )}

      {formQuery.isSuccess && !saveMutation.isSuccess && (
        <DisplayForm formConfig={formQuery.data.fieldsConfig} onSubmit={saveMutation.mutateAsync} />
      )}

      {formQuery.isError && <JourneyFormLoadError />}
    </Fragment>
  );
};
